import { Link } from 'react-router-dom';
import { BookOpen, GraduationCap, Mic, FileUser, Clock, Award, TrendingUp } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { localeUpperCase } from '../../lib/textCase';

// Mockup'ta 4. kart "Kariyer Koçluğu" (1:1 danışmanlık) idi — sistemde bire bir
// koçluk özelliği bulunmadığı için (karar gerekli — bkz. rapor) gerçekte var
// olan CV & Kariyer Hazırlığı sihirbazına (/programs/kabin-memurlugu/cv)
// yönlendiren bir kartla değiştirildi.
const CARDS = [
  {
    key: 'card1',
    icon: BookOpen,
    to: '/courses',
    headerBg: '#eef4ec',
    ctaClass: 'bg-[#0E1F3D] text-white',
  },
  {
    key: 'card2',
    icon: GraduationCap,
    to: '/programs/kabin-memurlugu',
    headerBg: '#eaf1f6',
    ctaClass: 'bg-[#0E1F3D] text-white',
  },
  {
    key: 'card3',
    icon: Mic,
    to: '/programs/kabin-memurlugu/interview',
    headerBg: '#0E1F3D',
    dark: true,
    ctaClass: 'bg-[#C9A227] text-[#241c02]',
  },
  {
    key: 'card4',
    icon: FileUser,
    to: '/programs/kabin-memurlugu/cv',
    headerBg: '#f4efdd',
    ctaClass: 'bg-[#0E1F3D] text-white',
  },
];

const META_ICONS = [Clock, Award, TrendingUp];

export default function FormatCards() {
  const { t, lang } = useLanguage();

  return (
    <section id="format" className="bg-[#F7F5F0] text-[#0E1F3D] py-16 md:py-20 px-6" data-testid="landing2-formats">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-xl mx-auto mb-11">
          <h2 className="landing2-display text-3xl md:text-[42px]">{localeUpperCase(t('landing2.formats.title'), lang)}</h2>
          <p className="text-[17px] text-[#5a6b60] mt-4 leading-relaxed">{t('landing2.formats.subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CARDS.map((card) => {
            const Icon = card.icon;
            return (
              <div key={card.key} className="fmt-card border border-[#e6e2d8] rounded-2xl overflow-hidden bg-white hover:-translate-y-1.5 transition-transform" data-testid={`format-${card.key}`}>
                <div className="p-6" style={{ background: card.headerBg }}>
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-[22px] ${card.dark ? 'bg-white/10' : 'bg-white'}`}>
                    <Icon size={22} className={card.dark ? 'text-[#C9A227]' : 'text-[#0E1F3D]'} aria-hidden="true" />
                  </div>
                  <h3 className={`font-black text-[21px] mt-4 mb-1.5 leading-tight ${card.dark ? 'text-white' : 'text-[#0E1F3D]'}`}>
                    {t(`landing2.formats.${card.key}.title`)}
                  </h3>
                  <p className={`text-sm leading-snug ${card.dark ? 'text-[#c5cfdd]' : 'text-[#5a6b60]'}`}>
                    {t(`landing2.formats.${card.key}.desc`)}
                  </p>
                </div>
                <div className="p-[22px]">
                  <div className="flex flex-col gap-3 mb-[18px]">
                    {[1, 2, 3].map((n) => {
                      const MIcon = META_ICONS[n - 1];
                      return (
                        <div key={n} className="flex items-center gap-2 text-sm font-semibold text-[#46564c]">
                          <MIcon size={15} className="text-[#16794a]" aria-hidden="true" />
                          {t(`landing2.formats.${card.key}.meta${n}`)}
                        </div>
                      );
                    })}
                  </div>
                  <Link
                    to={card.to}
                    className={`block text-center text-sm font-extrabold py-3 rounded-xl ${card.ctaClass} hover:brightness-110 transition-[filter]`}
                  >
                    {t(`landing2.formats.${card.key}.cta`)}
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
